module.exports = __webpack_public_path__ + "img/fondo-konecta.facd7f89.png";